import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { RecordInsertCategoryWise } from './RecordInsertCategoryWise';
import { CategoryWiseItemList } from './CategoryWiseItemList';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class PlantWiseItem extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            plantObject: {
                selectType: "",
                selectCategory: "",
                selectPlant: "",
                categoryPlant: "",
                itemTypeId: 1,
                types: [
                    {
                        value: 1,
                        label: "RAW MATERIAL"
                    },
                    {
                        value: 2,
                        label: "FINISHED GOODS"
                    },
                    {
                        value: 3,
                        label: "SEMI FINISHED"
                    },
                    {
                        value: 4,
                        label: "SCRAP MATERIAL"
                    },
                ],
                idPlant: 0,
                plantList: [],
                categoryId: 0,
                categoryList: [],
                rowData: [],
                colDefs: [],

            },
            plantObjectCategory: {
                idPlant: 0,
                plantList: [],
                rowData: [],
                colDefs: [],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                selectType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "select type"
                        ),
                    },
                ],
                selectCategory: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                selectPlant: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item category"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        this.setState({ isModalOpen: true }, () => {
            this.resetDetailsFields();
            // this.getMasterExpenseAccGroupCount();
        })
    };

    onRowDoubleClicked = (event) => {
        this.getMasterExpenseAccountGroupSelectbyID(event.data.idAccountGroup);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.plantObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.plantObject;
        details[name] = value;
        this.setState({ plantObject: details });
    }

    getPinnedWidth = (key) => {
        // const pinnedCol = {
        //     "idCashWithdraw": window.innerWidth * 0.06,
        //     "sR.No": window.innerWidth * 0.04,
        //     "employeeName": window.innerWidth * 0.18,
        // }
        // return pinnedCol[key]
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let plantObject = this.state.plantObject;
        plantObject.processNo = "";
        plantObject.processName = "";
        plantObject.processDesc = "";
        plantObject.remarks = "";
        this.setState({
            plantObject: plantObject, validState: validState
        });
    }

    handleChangeFroDropdown = (event, name) => {
        if (name === "plantObjectCategoryPlantId") {
            let plantObjectCategory = this.state.plantObjectCategory;
            let value = event.value;
            plantObjectCategory.idPlant = value;
            this.setState({ plantObjectCategory: plantObjectCategory });
        } else {
            let details = this.state.plantObject;
            let value = event.value;
            details[name] = value;
            this.setState({ plantObject: details }, () => {
                if (name === 'itemTypeId') {
                    this.getMaster_ItemCategorySelectbyItemType(event.label);
                }
            });
        }

    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.getAllDropdownForStockMaster();
                this.getMaster_ItemCategorySelectbyItemType("RAW MATERIAL");
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100);
    }

    getMaster_ItemCategorySelectbyItemType = (type) => {
        let request = [
            type,
            this.state.idCompany
        ];
        this.masterEntryServices.getMaster_ItemCategorySelectbyItemType(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = this.state.plantObject;
                let itemCategoryList = response.responseItem.responseContent;
                data.categoryList = itemCategoryList.map((p) => ({ value: p.idItemCategory, label: p.itemCategory + ' - ' + p.itemCategoryDesc }));
                this.setState({
                    itemObject: data
                });
            }
        });
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    getAllDropdownForStockMaster = () => {
        this.masterEntryServices.getAllDropdownForStockMaster(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.plantObject;
                let plantObjectCategory = this.state.plantObjectCategory;
                data.plantList = allData.filter(item => item.source === 'Master_Plant');
                plantObjectCategory.plantList = allData.filter(item => item.source === 'Master_Plant');
                //data.selectProcessList = allData.filter(item => item.source === 'Master_Process');
                this.setState({
                    productObject: data,
                    plantObjectCategory: plantObjectCategory
                });
            }
        });
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [label, this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.plantObject;
                data = data.map((x) => ({
                    value: x.idItem,
                    label: x.itemCategory + ' - ' + x.itemName,
                }));
                itemObject.categoryList = data;
                itemObject.categoryId = 0;
                this.setState({
                    plantObject: itemObject,
                });
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let category = this.state.plantObject.types.find((x) => x.value === this.state.plantObject.itemTypeId).value;
        // let request = [
        //     category ? category : 0,
        //     this.state.plantObject.idPlant,
        //     this.state.idCompany
        // ];
        let request = {
            formname: "Plant wise item",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: category ? category : 0,
            //idFinancialYear : null,
            idPlant: this.state.plantObject.idPlant,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                //debugger;
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    let itemObject = this.state.plantObject;
                    if (data.length > 0) {
                        data.forEach((x) => {
                            x.checkBoxCol = false;
                        });

                        const columnPriority = [
                            "checkBoxCol", "itemCategory", "drawingNo", "itemName", "unitDescription", "searchText"
                        ];
                        const allKeys = Object.keys(data[0]);

                        const sortedKeys = allKeys.sort((a, b) => {
                            const indexA = columnPriority.indexOf(a);
                            const indexB = columnPriority.indexOf(b);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                        });

                        const dynamicColDefs = sortedKeys.map((key) => {
                            const isCheckBoxCol = key === "checkBoxCol";

                            return {
                                field: key.includes(".") ? key.replace(/\./g, "_") : key,
                                headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
                                    key.replace(/([A-Z])/g, ' $1').slice(1),
                                minWidth: this.getColumnWidth(key) !== undefined
                                    ? this.getColumnWidth(key)
                                    : window.innerWidth * 0.06,
                                flex: 1,
                                filter: true,
                                floatingFilter: true,
                                hide: ["idItemCategory", "idItem"].includes(key),
                                width: this.getPinnedWidth(key),
                                valueGetter: (params) => params.data[key],
                                ...(isCheckBoxCol && {
                                    cellRenderer: 'agCheckboxCellRenderer',
                                    editable: true,
                                }),
                            };
                        });

                        itemObject.rowData = data;
                        itemObject.colDefs = dynamicColDefs;
                    }

                    this.setState({
                        plantObject: itemObject,
                    }, () => {
                        this.setPermissions(permissions);
                    });
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getMasterItemSelectForUpdatePlantWise = () => {
        let category = this.state.plantObject.types.find((x) => x.value === this.state.plantObject.itemTypeId).label;
        let request = [
            category ? category : 0,
            this.state.plantObject.idPlant,
            this.state.idCompany
        ];

        this.masterEntryServices.getMasterItemSelectForUpdatePlantWise(request)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    let itemObject = this.state.plantObject;

                    if (data.length > 0) {
                        data.forEach((x) => {
                            x.checkBoxCol = false;
                        });

                        const columnPriority = [
                            "checkBoxCol", "itemCategory", "drawingNo", "itemName", "unitDescription", "searchText"
                        ];
                        const allKeys = Object.keys(data[0]);

                        const sortedKeys = allKeys.sort((a, b) => {
                            const indexA = columnPriority.indexOf(a);
                            const indexB = columnPriority.indexOf(b);
                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return 1;
                            if (indexB === -1) return -1;
                            return indexA - indexB;
                        });

                        const dynamicColDefs = sortedKeys.map((key) => {
                            const isCheckBoxCol = key === "checkBoxCol";

                            return {
                                field: key.includes(".") ? key.replace(/\./g, "_") : key,
                                headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() +
                                    key.replace(/([A-Z])/g, ' $1').slice(1),
                                minWidth: this.getColumnWidth(key) !== undefined
                                    ? this.getColumnWidth(key)
                                    : window.innerWidth * 0.06,
                                flex: 1,
                                filter: true,
                                floatingFilter: true,
                                hide: ["idItemCategory", "idItem"].includes(key),
                                width: this.getPinnedWidth(key),
                                valueGetter: (params) => params.data[key],
                                ...(isCheckBoxCol && {
                                    cellRenderer: 'agCheckboxCellRenderer',
                                    editable: true,
                                }),
                            };
                        });

                        itemObject.rowData = data;
                        itemObject.colDefs = dynamicColDefs;
                    }

                    this.setState({
                        plantObject: itemObject,
                    });
                }
            });
    };



    getMasterPlantWiseItemSelect = () => {
        let request = [this.state.plantObjectCategory.idPlant, this.state.idCompany];
        this.masterEntryServices.getMasterPlantWiseItemSelect(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = { ...this.state.plantObjectCategory };
                if (data.length > 0) {
                    // data.map((x) => {
                    //     x.isCheckBox = false;
                    //     x.checkBoxCol = `${<input type='CheckBox' checked={x.isCheckBox} />}`;
                    // })
                    const columnPriority = [
                        "idItemCategory", "itemCategory", "drawingNo", "itemName", "unitDescription", "searchText"
                    ];
                    const allKeys = Object.keys(data[0]);
                    const sortedKeys = allKeys.sort((a, b) => {
                        const indexA = columnPriority.indexOf(a);
                        const indexB = columnPriority.indexOf(b);
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                    });

                    const dynamicColDefs = sortedKeys.map((key) => ({
                        field: key.includes(".") ? key.replace(/\./g, "_") : key,
                        headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                        minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                        flex: 1,
                        filter: true,
                        floatingFilter: true,
                        hide: ["idItem"].includes(key) ? true : false,
                        width: this.getPinnedWidth(key),
                        valueGetter: (params) => params.data[key],
                    }));
                    itemObject.rowData = data;
                    itemObject.colDefs = dynamicColDefs;
                }
                this.setState({
                    plantObjectCategory: itemObject,
                });
            }
        });
    }

    saveRecords = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.save);
            return;
        }
        let request = [];
        let data = this.state.plantObject;
        data.rowData.map((x) => {
            if (x.checkBoxCol === true) {
                let obj = {
                    itemType: data.types.find(i => i.value === data.itemTypeId)?.label,
                    iDItemCategory: x.idItemCategory,
                    iDItem: x.idItem,
                    iDplant: data.idPlant,
                    iDCompany: this.state.idCompany,
                    e_Date: new Date().toISOString(),
                };
                request.push(obj);
            }
        });

        if (request.length > 0) {
            this.masterEntryServices.submitMasterPlantItemDetails(request).then((response) => {

                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    let itemObject = this.state.plantObject;
                    itemObject.itemTypeId = 1;
                    itemObject.rowData = [];
                    itemObject.colDefs = [];
                    itemObject.idPlant = 0;
                    itemObject.categoryId = 0;
                    itemObject.categoryList = [];
                    //this.SwalServices.Success("Saved successfully.");
                    this.setState({
                        plantObject: itemObject,
                    }, () => {
                        this.SwalServices.Success("Saved successfully.");
                        this.getMaster_ItemCategorySelectbyItemType("RAW MATERIAL");
                    });
                }
            });
        }
    }

    getColumnWidth = (key) => {
        const colwidth = {
            "itemCategory": window.innerWidth * 0.15,
            "itemName": window.innerWidth * 0.2,
            "unitDescription": window.innerWidth * 0.05,
            "drawingNo": window.innerWidth * 0.15,
            "searchText": window.innerWidth * 0.13,
            "checkBoxCol": window.innerWidth * 0.04,
        }
        return colwidth[key]
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            "itemCategory": window.innerWidth * 0.1,
            "idItemCategory": window.innerWidth * 0.06,
            "itemName": window.innerWidth * 0.3,
            "unitDescription": window.innerWidth * 0.05,
            "drawingNo": window.innerWidth * 0.13,
            "searchText": window.innerWidth * 0.1,
            "checkBoxCol": window.innerWidth * 0.04,
        }
        return colwidth[key]
    }

    render() {
        return (
            <div className='tax-structure-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <div className='toggle-btns absolute top-[-54px] right-0 flex items-center bg-gray-100 rounded-[8px] shadow-normalShadow'>
                            <div
                                className={`plant-toggle text-[16px] py-[5px] px-[15px] font-semibold cursor-pointer rounded-l-lg transition-all duration-200 ${this.state.isShown === false
                                    ? 'text-white bg-blue'
                                    : 'text-blue bg-lightBlue hover:bg-[#3f8cff33]'
                                    }`}
                                onClick={() => this.setState({ isShown: false })}
                            >
                                Record insert category wise
                            </div>
                            <div
                                className={`plant-toggle text-[16px] py-[5px] px-[15px] font-semibold cursor-pointer rounded-r-lg transition-all duration-200 ${this.state.isShown === true
                                    ? 'text-white bg-blue'
                                    : 'text-blue bg-lightBlue hover:bg-[#3f8cff33]'
                                    }`}
                                onClick={() => this.setState({ isShown: true })}
                            >
                                Category wise item list
                            </div>
                        </div>

                        {/* <ItemRateVendorWisePopUp
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            plantObject={this.state.plantObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                        /> */}
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[10px] pt-[10px] px-[10px]">
                            {this.state.isShown ? (
                                <CategoryWiseItemList
                                    plantObjectCategory={this.state.plantObjectCategory}
                                    handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                                    viewRecords={this.getMasterPlantWiseItemSelect.bind(this)}
                                />
                            ) : (
                                <RecordInsertCategoryWise
                                    plantObject={this.state.plantObject}
                                    handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                                    viewRecords={this.procSelectAllRecordsSP.bind(this)}
                                    saveRecords={this.saveRecords.bind(this)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
